import React from 'react';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { BarChartVogelvluchtMobile } from '../../BarChart/BarChart';
import { InfoPanelMobile } from '../../InfoPanelMobile/InfoPanelMobile';

export const VogelvluchtMobile = (props: any) => {
  const { data, allIndicators, interactieveToolPath, aantalInwoners } = props;
  const {
    tableWidth,
    colors,
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    interfaceColor,
    barColors,
    locale,
  } = useData();

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <h5 className="page-title-mobile">
            {selectedGemeente.label} (
            {locale.format(aantalInwoners.d3format)(
              aantalInwoners?.aantalInwoners,
            )}{' '}
            inwoners - {aantalInwoners?.jaar}) in vogelvlucht
          </h5>
          <p className={'page-subtitle-mobile'}>
            Hoe tevreden zijn inwoners uit {selectedGemeente.label} over het
            thema {selectedTopic.thema}? Vergelijk {selectedGemeente.label} met
            de benchmark {selectedBenchmarks[0].label} op een kernset van
            indicatoren uit de burgerbevraging Gemeente-Stadsmonitor{' '}
            {data.length > 0 && data[0].jaar}.
          </p>
          <div>
            <InfoPanelMobile
              allIndicators={allIndicators}
              data={data}
              interactieveToolPath={interactieveToolPath}
            />
          </div>
          <hr style={{ marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia
        style={{
          width: '100%',
          height: data.length === 0 ? '160px' : data.length * 50 + 60 + 'px',
        }}
      >
        {data !== undefined && data.length > 0 ? (
          <BarChartVogelvluchtMobile
            // data={data.sort((a: any, b: any) => {
            //   return b.value - a.value;
            // })}
            data={data}
            layout="vertical"
            showLegend={true}
            fieldKey="id"
            colors={barColors}
            interfaceColor={interfaceColor}
            selectedGemeente={selectedGemeente}
            selectedBenchmarks={selectedBenchmarks}
            locale={locale}
          ></BarChartVogelvluchtMobile>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {' '}
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
    </Card>
  );
};
